export const replaceSpecialCharacter = (text: string, replacingWith: string) => {
    return text.replace(/[^a-zA-Z0-9]/g, replacingWith)
}